<template>
  <div class="lk__reserve-item">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray">
          Теплоход
        </div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table text-blue">
          <a
            class="text-blue"
            :href="localeUrl('/ships/' + item.ship.id + '/')"
          >
            {{ item.ship.name }}
          </a>
        </div>
      </div>
      <hr class="w-100 my-1" />
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray">
          Отход
        </div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table">
          {{ dateFromDDMM }}
        </div>
      </div>
      <hr class="w-100 my-1" />
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray">
          Прибытие
        </div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table">
          {{ dateToDDMM }}
        </div>
      </div>
      <hr class="w-100 my-1" />
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray">Дней</div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table">
          {{ item.days }}
        </div>
      </div>
      <hr class="w-100 my-1" />
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray mr-22">
          Маршрут
        </div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table text-blue">
          <span v-for="(point, index) in item.routes_array" :key="index">
            <a
              :href="localeUrl('/river-cruises/' + item.id + '/')"
              class="text-blue"
            >
              {{ point }}
            </a>
          </span>
        </div>
      </div>
      <hr class="w-100 my-1" />
      <div class="d-flex flex-row">
        <div class="col-4 col-sm-2 p-0 popular__text-table text-gray">
          Цена от
        </div>
        <div class="col-8 col-sm-10 pl-1 pr-0 popular__text-table">
          <span v-if="item.price_from">
            {{ $rub(item.price_from) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CruiseListViewCard.vue",
  props: ["item", "compare"],
  computed: {
    dateFromDDMM() {
      return this.$dateRaw(this.item.date_from).format("DD.MM");
    },
    dateFromHHMM() {
      return this.$dateRaw(this.item.date_from).format("HH:mm");
    },
    dateToDDMM() {
      return this.$dateRaw(this.item.date_to).format("DD.MM");
    },
    dateToHHMM() {
      return this.$dateRaw(this.item.date_to).format("HH:mm");
    },
  },
  methods: {
    localeUrl(url) {
      if (
        typeof window.transferState !== "undefined" &&
        window.transferState.get("i18n").locale !== "ru"
      ) {
        return (url = "/" + window.transferState.get("i18n").locale + url);
      }
      return url;
    },
    updateCompare(cruiseId) {
      this.$store.commit("updateCompare", cruiseId);
    },
  },
};
</script>
